import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { TopBar } from "./TopBar";
import { CommandPalette } from "./CommandPalette";
import { InstallPrompt } from "./InstallPrompt";
import { useApplyThemeAttribute } from "@/lib/use-theme";

export function AppShell() {
  // Sets `data-theme="light|dark"` on <html> so globals.css can scope
  // dark-mode tweaks (text colors, borders) where needed.
  useApplyThemeAttribute();
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  return (
    <div className="flex h-full">
      <Sidebar
        mobileOpen={mobileSidebarOpen}
        onMobileClose={() => setMobileSidebarOpen(false)}
      />
      <div className="flex flex-1 flex-col overflow-hidden">
        <TopBar onMobileMenuClick={() => setMobileSidebarOpen(true)} />
        <main className="flex-1 overflow-auto bg-brand-background p-4 sm:p-6">
          <Outlet />
        </main>
      </div>
      <CommandPalette />
      <InstallPrompt />
    </div>
  );
}
